<template>
    <div id="detail-content" v-if="show">
        <Types
            v-if="content === 'Types'"
            :types="project.Types"
            :contentInitiated="initiated"
            :mobile="mobile"
            @content-initiated="$emit('content-initiated', $event)"
        />
        <Directives
            v-if="content === 'Directives'"
            :directives="project.Directives"
            :contentInitiated="initiated"
            :mobile="mobile"
            @content-initiated="$emit('content-initiated', $event)"
        />
        <Process
            v-if="content === 'Process'"
            :process="Process()"
            :contentInitiated="initiated"
            :mobile="mobile"
            @content-initiated="$emit('content-initiated', $event)"
        />
    </div>
</template>

<script>
import Types from "@/components/Projects/Project/Detail/Types/Types.vue";
import Directives from "@/components/Projects/Project/Detail/Directives/Directives.vue";
import Process from "@/components/Projects/Project/Detail/Process/Process.vue";
import { projectModel } from "@/models";

export default {
    name: "ProjectDetailContent",
    props: {
        show: Boolean,
        content: String,
        project: Object,
        initiated: Boolean,
        mobile: Boolean
    },
    components: {
        Types,
        Directives,
        Process
    },
    methods: {
        Process: function() {
            const { Tools, Languages } = this.project.ProjectProcess;
            const tools = [];
            const languages = [];

            // Collect areas
            for (const tool of Tools) {
                tools.push({
                    ID: tool.ID,
                    Name: tool.Name
                });
            }
            for (const language of Languages) {
                languages.push({
                    ID: language.ID,
                    Name: language.Language
                });
            }

            // Add areas to process
            const process = [];
            if (tools.length) {
                process.push({
                    label: "Tools",
                    items: tools
                });
            }
            if (languages.length) {
                process.push({
                    label: "Languages & Frameworks",
                    items: languages
                });
            }

            return process;
        }
    },
    emits: [ ...projectModel.emits ]
};
</script>